import React from "react";
import type { SourceId } from "../../types";
import { SOURCE_LABELS } from "../../types";

const COLORS: Record<SourceId, string> = {
  ifood: "bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300",
  carrefour: "bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-300",
  supernosso: "bg-rose-100 text-rose-800 dark:bg-rose-900/40 dark:text-rose-300",
  villefort: "bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300",
};

export function SourceBadge({ source }: { source: SourceId }) {
  return (
    <span
      className={`inline-block px-2 py-0.5 rounded text-xs font-medium ${COLORS[source]}`}
    >
      {SOURCE_LABELS[source]}
    </span>
  );
}
